<div class="content">
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Work Anniversaries</h2>
    </div>
  </div>

  <div class="card w-100">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap">
      <h5>💍 Employee Anniversaries</h5>

      <div class="d-flex gap-2">
        <select
          class="form-select form-select-sm"
          style="width: 90px"
          [(ngModel)]="pageLimit"
          (change)="loadAnniversaries()"
        >
          <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">{{ limit }}</option>
        </select>

        <input
          type="text"
          [(ngModel)]="search"
          (ngModelChange)="onFilterChange()"
          class="form-control"
          placeholder="Search Employees"
        />
      </div>
    </div>

    <div class="card-body p-0">
      <table class="table table-hover mb-0" *ngIf="anniversaryList.length > 0; else noData">
        <thead>
          <tr>
            <th>Employee</th>
            <th>Department</th>
            <th>Joining Date</th>
            <th>Years</th>
            <th class="text-end">Action</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let emp of anniversaryList">
            <td>
              <div class="d-flex align-items-center">
                <img
                  *ngIf="emp.picture; else initials"
                  [src]="apiEndpoint + '/uploads/' + emp.picture"
                  class="rounded-circle border border-2"
                  style="width: 40px; height: 40px"
                  alt="img"
                />

                <ng-template #initials>
                  <div
                    class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                    style="width: 40px; height: 40px"
                  >
                    {{ emp.firstName[0] }}{{ emp.lastName[0] }}
                  </div>
                </ng-template>
                <div class="ms-2">{{ emp.firstName }} {{ emp.lastName }}</div>
              </div>
            </td>

            <td>{{ emp.designation?.department?.departmentName || 'N/A' }}</td>

            <td>{{ emp.joiningDate }}</td>
            <td>
              <span class="btn btn-sm btn-success">
                {{ getCompletedYears(emp) }} Year{{ getCompletedYears(emp) > 1 ? 's' : '' }}
              </span>
            </td>
            <td class="text-end">
              <!-- Enable sending wish only on today -->
              <button
                *ngIf="isTodayCelebration(emp, 'anniversary')"
                class="btn btn-sm btn-primary ms-1"
                (click)="sendWish(emp.id)"
              >
                Send Wish
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <ng-template #noData>
        <div class="text-center">Record not available</div>
      </ng-template>
    </div>

    <div
      class="d-flex justify-content-between align-items-center p-2"
      *ngIf="anniversaryList.length > 0"
    >
      <div>
        Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of {{ totalCount }}
      </div>

      <app-pagination
        [currentPage]="currentPage"
        [pageSize]="pageLimit"
        [totalRows]="totalCount"
        (pageChange)="onPageChange($event)"
      >
      </app-pagination>
    </div>
  </div>
</div>
